<template>
  <div class="up-box">
    <el-upload
      class="upload-demo"
      style="width: 360px"
      drag
      :accept="accept"
      :action="actionUrl"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
      name="uploadFile"
      :show-file-list="false"
      :on-error="onError"
      :on-remove="onRemove"
      :disabled="!disabled"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        <div>将文件拖到此处，或<em>点击上传</em></div>
        <div>{{ tips }}</div>
      </div>
    </el-upload>
    <img v-if="imgUrl" :src="imgUrl" alt="" />
  </div>
</template>
<script>
export default {
  props: {
    accept: {
      type: String,
      default: ".jpg,.png,.gif",
    },
    tips: {
      type: String,
      default: "（尺寸：200*200，jpg、png、gif）",
    },
    imgUrl: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
    };
  },
  methods: {
    beforeUpload(file) {
      const ext = file.name.split(".")[file.name.split(".").length - 1];
      const extList = this.$props.accept.replaceAll(".", "").split(",");
      if (!extList.includes(ext)) {
        this.$message.warning(
          `只能上传${this.$props.accept.replaceAll(".", "")}格式文件`
        );
        return false;
      }
      return true;
    },
    onSuccess(response, file, fileList) {
      if (response.error !== 10000) {
        this.$message.error("上传失败");
      } else {
        this.$emit("update:imgUrl", response.data);
      }
    },
    onError(response) {
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }
      this.$message.error("上传失败");
    },
    onRemove() {
      this.$emit("update:imgUrl", "");
    },
  },
};
</script>
<style scoped>
.up-box {
  display: flex;
}
.up-box img {
  width: 360px;
  height: 180px;
  margin-left: 20px;
  /* object-fit: contain; */
}
</style>


// WEBPACK FOOTER //
// UploadDragImg.vue?02b32bd5